import { Injectable } from '@angular/core';

import { RelatedCard, RidangoEpic, RidangoReduxAction, UserTicketAction, UserTicketActionsEnum } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { AccountTicketsService } from '../account-tickets.service';
import { AccountTicketsActions } from './account-tickets.actions';

@Injectable({
    providedIn: 'root',
})
export class AccountTicketsEpics implements RidangoEpic {
    constructor(
        private actions: AccountTicketsActions,
        private service: AccountTicketsService
    ) {}

    register() {
        return [this.fetchAccountTickets, this.fetcRelatedCardTickets];
    }

    fetchAccountTickets = (action$: ActionsObservable<any>) =>
        action$.ofType(AccountTicketsActions.FETCH_ACCOUNT_TICKETS).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchActiveTickets().pipe(
                    map((response: any[]) => {
                        // transform payload to state-acceptable

                        // setting actions for tickets
                        const tickets = response.map(ticket => {
                            ticket.actions = [];
                            if (ticket.card_type === 'Q') {
                                ticket.actions.push(new UserTicketAction(UserTicketActionsEnum.QR));
                            }
                            if (ticket.refund_code) {
                                ticket.actions.push(new UserTicketAction(UserTicketActionsEnum.REFUND));
                            }
                            return ticket;
                        });
                        // normalizing tickets by doc num
                        const normalized = tickets.reduce((acc, val) => {
                            return { ...acc, [val.doc_num]: val };
                        }, {});

                        // setting up state object
                        const stateObject = {
                            byId: normalized,
                            allIds: response.map(t => t.doc_num),
                            emailTicketIds: response
                                .filter((t) => {
                                    return t.card_type === 'Q' && t.product.product_properties.filter(pp => pp.code === 'VOUCHER').length === 0;
                                })
                                .map(t => t.doc_num),
                            travelCardTicketIds: response
                                .filter((t) => {
                                    return t.card_type === 'U';
                                })
                                .map(t => t.doc_num),
                            voucherTicketIds: response
                                .filter((t) => {
                                    return t.card_type === 'Q' && t.product.product_properties.filter(pp => pp.code === 'VOUCHER').length > 0;
                                })
                                .map(t => t.doc_num),
                            voucherSubTicketIds: response
                                .filter((t) => {
                                    return t.card_type === 'S';
                                })
                                .map(t => t.doc_num),
                        };
                        return this.actions.fetchAccountTicketsSuccess(stateObject);
                    }),
                    catchError((error) => of(this.actions.fetchAccountTicketsFailed(error)))
                );
            })
        )


    fetcRelatedCardTickets = (action$: ActionsObservable<any>) =>
        action$.ofType(AccountTicketsActions.FETCH_ACCOUNT_RELATED_CARD_TICKETS).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchTicketsByRelatedCard(action.payload).pipe(
                    map((response: any[]) => {
                        // setting actions for tickets
                        const tickets = response.map(ticket => {
                            // TODO: ticket actions, where should get those ?
                            ticket.actions = [];
                            ticket.actions.push(new UserTicketAction(UserTicketActionsEnum.DELETE), new UserTicketAction(UserTicketActionsEnum.RENEW));

                            // if (ticket.card_type === 'Q') {
                            //     ticket.actions.push(new UserTicketAction(UserTicketActionsEnum.QR));
                            // }
                            // if (ticket.refund_code) {
                            //     ticket.actions.push(new UserTicketAction(UserTicketActionsEnum.REFUND));
                            // }
                            return ticket;
                        });
                        // normalizing tickets by doc num
                        const normalized = tickets.reduce((acc, val) => {
                            return { ...acc, [val.doc_num]: val };
                        }, {});

                        // setting up state object
                        const stateObject = {
                            byId: normalized,
                            allIds: response.map(t => t.doc_num),
                            selectedRelatedCardTicketIds: tickets.map(t => t.doc_num)
                        };
                        return this.actions.fetchAccountRelatedCardTicketsSuccess(stateObject);
                    }),
                    catchError((error) => of(this.actions.fetchAccountRelatedCardTicketsFailed(error)))
                );
            })
        )

}
